import axios from 'axios';
import apiConfig from '../api.config';

export default function updatePmsConfigRequest({ hotelId, fields, pms }) {
  const {
    host,
    URIs: { pmsConfigUpdate },
  } = apiConfig;

  const uri = `${host}${pmsConfigUpdate}`.replace(':hotelId', hotelId);

  return axios
    .put(uri, JSON.stringify({ fields, pms }), {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
